import React, { PropTypes } from 'react';
import { Dropdown, Form, Input } from 'semantic-ui-react';
import ReferenceDropdown from 'common/components/ReferenceDropdown';
import MultiReferenceCheckbox from 'common/components/MultiReferenceCheckbox';

const RatDiagnosis = ({
  onValueChange,
  taskDiagnosis,
  timeUnits,
  contractTypes,
  infestationLevels,
  infraTypes,
  ratSpecies,
  placesRef,
  accessibilityRef,
  dirty,
}) => {
  const timeUnitOptions = timeUnits.map(tu => ({
    key: tu.id,
    text: tu.label,
    value: tu.id,
  }));

  const onNumberValueChange = field => (event, data) => {
    onValueChange(field)(event, { ...data, value: parseInt(data.value, 10) });
  };

  const formClassName = dirty ? 'dirty' : '';

  return (
    <Form className={formClassName}>
      <Form.Group widths="equal">
        <ReferenceDropdown
          refs={contractTypes}
          onChange={onValueChange('contract_type_ref')}
          title="Type de contrat"
          value={taskDiagnosis.contract_type_ref}
        />
        <Form.Field>
          <label>Durée moyenne des visites</label>
          <Input
            label={
              <Dropdown
                value={taskDiagnosis.average_time_unit_ref}
                onChange={onValueChange('average_time_unit_ref')}
                options={timeUnitOptions}
              />
            }
            labelPosition="right"
            type="number"
            value={taskDiagnosis.average_time || ''}
            onChange={onNumberValueChange('average_time')}
          />
        </Form.Field>
      </Form.Group>

      <Form.Group widths="equal">
        <ReferenceDropdown
          refs={infestationLevels}
          onChange={onValueChange('infestation_level_ref')}
          title="Niveau d’infestation"
          value={taskDiagnosis.infestation_level_ref}
        />

        <ReferenceDropdown
          refs={infraTypes}
          onChange={onValueChange('site_infrastructure_ref')}
          title="Type d’infrastructure"
          value={taskDiagnosis.site_infrastructure_ref}
        />
      </Form.Group>

      <MultiReferenceCheckbox
        label="Espèces"
        values={taskDiagnosis.targets}
        otherValue={taskDiagnosis.targets_other}
        references={ratSpecies}
        onChangeValues={onValueChange('targets')}
        onChangeOther={onValueChange('targets_other')}
        withOther
      />

      <MultiReferenceCheckbox
        label="Lieux traités"
        values={taskDiagnosis.places}
        otherValue={taskDiagnosis.places_other}
        references={placesRef}
        onChangeValues={onValueChange('places')}
        onChangeOther={onValueChange('places_other')}
        withOther
      />

      <MultiReferenceCheckbox
        label="Accessibilité des lieux traités"
        values={taskDiagnosis.accessibility}
        references={accessibilityRef}
        onChangeValues={onValueChange('accessibility')}
      />

      <Form.TextArea
        label="Commentaire lié à l’activité"
        value={taskDiagnosis.customer_directive || ''}
        onChange={onValueChange('customer_directive')}
      />
    </Form>
  );
};

RatDiagnosis.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  taskDiagnosis: PropTypes.object.isRequired,
  timeUnits: PropTypes.array.isRequired,
  infestationLevels: PropTypes.array.isRequired,
  infraTypes: PropTypes.array.isRequired,
  ratSpecies: PropTypes.array.isRequired,
  contractTypes: PropTypes.array.isRequired,
};

export default RatDiagnosis;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/components/RatDiagnosis.js